import { useEffect, useRef } from 'react';
import { useAuthStore } from '../store/authStore';
import { useAuth } from './useAuth';

const IDLE_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutos

const IDLE_EVENTS = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'] as const;

export function useIdleTimeout() {
  const { isAuthenticated } = useAuthStore();
  const { logout } = useAuth();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!isAuthenticated) return;

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        logout();
      }, IDLE_TIMEOUT_MS);
    };

    IDLE_EVENTS.forEach(event => window.addEventListener(event, resetTimer, { passive: true }));
    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      IDLE_EVENTS.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }, [isAuthenticated, logout]);
}
